module.exports = __webpack_public_path__ + "img/wxShare.876252cc.png";